import { forwardRef } from "react";
import cn from "mcn";

export const SoundAlertIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    active?: boolean;
    size?: number;
  }
>(({ active, size = 18, className, ...props }, ref) => {
  if (active) {
    return (
      // biome-ignore lint/a11y/noSvgWithoutTitle: Icon with external label
      <svg
        width={size}
        height={size}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={cn(className)}
        ref={ref}
        {...props}
      >
        <path
          d="M9.84251 2.3338C10.1755 2.49049 10.3897 2.83401 10.3897 3.2137V14.785C10.3897 15.1647 10.1755 15.5082 9.84251 15.6649C9.50956 15.8216 9.1187 15.7583 8.84655 15.5052L4.9409 11.8922H2.97794C1.95593 11.8922 1.125 11.0273 1.125 9.96361V8.03506C1.125 6.97135 1.95593 6.10652 2.97794 6.10652H4.9409L8.84655 2.4935C9.1187 2.24038 9.50956 2.18012 9.84251 2.3338ZM14.8223 4.50944C16.073 5.57014 16.875 7.18831 16.875 8.99934C16.875 10.8104 16.073 12.4285 14.8223 13.4892C14.5241 13.7424 14.0869 13.6941 13.8437 13.3838C13.6005 13.0734 13.6468 12.6184 13.945 12.3653C14.886 11.5697 15.4853 10.3584 15.4853 8.99934C15.4853 7.64031 14.886 6.42894 13.945 5.63041C13.6468 5.37728 13.6034 4.92227 13.8437 4.61189C14.084 4.30152 14.5241 4.25632 14.8223 4.50642V4.50944ZM13.0707 6.75439C13.6932 7.28474 14.0956 8.09232 14.0956 8.99934C14.0956 9.90635 13.6932 10.7139 13.0707 11.2443C12.7725 11.4974 12.3353 11.4492 12.0921 11.1388C11.8489 10.8284 11.8952 10.3734 12.1934 10.1203C12.5061 9.85513 12.7059 9.45134 12.7059 8.99934C12.7059 8.54733 12.5061 8.14354 12.1934 7.87535C11.8952 7.62223 11.8518 7.16722 12.0921 6.85684C12.3324 6.54647 12.7725 6.50127 13.0707 6.75137V6.75439Z"
          fill="currentColor"
        />
      </svg>
    );
  }

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Icon with external label
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      ref={ref}
      {...props}
    >
      <path
        d="M5.24748 7.36975L8.53194 4.36842V13.6286L5.24748 10.6302C5.11856 10.5127 4.95155 10.4464 4.78162 10.4464H2.20327C2.07435 10.4464 1.96887 10.3379 1.96887 10.2054V7.79464C1.96887 7.66205 2.07435 7.55357 2.20327 7.55357H4.78162C4.95448 7.55357 5.12149 7.48728 5.24748 7.36975ZM9.06519 2.25C8.85131 2.25 8.64621 2.33136 8.48506 2.476L4.51499 6.10714H2.20327C1.29792 6.10714 0.5625 6.8635 0.5625 7.79464V10.2054C0.5625 11.1365 1.29792 11.8929 2.20327 11.8929H4.51499L8.48506 15.524C8.64621 15.6686 8.85131 15.75 9.06519 15.75C9.54863 15.75 9.93831 15.3492 9.93831 14.852V3.14799C9.93831 2.65078 9.54863 2.25 9.06519 2.25ZM13.0148 6.31808C12.7393 6.03482 12.294 6.03482 12.0215 6.31808C11.749 6.60134 11.7461 7.05937 12.0215 7.33962L13.633 8.99699L12.0215 10.6544C11.7461 10.9376 11.7461 11.3956 12.0215 11.6759C12.2969 11.9561 12.7423 11.9592 13.0148 11.6759L14.6262 10.0185L16.2377 11.6759C16.5131 11.9592 16.9585 11.9592 17.2309 11.6759C17.5034 11.3926 17.5064 10.9346 17.2309 10.6544L15.6195 8.99699L17.2309 7.33962C17.5064 7.05636 17.5064 6.59833 17.2309 6.31808C16.9555 6.03783 16.5102 6.03482 16.2377 6.31808L14.6262 7.97545L13.0148 6.31808Z"
        fill="currentColor"
      />
    </svg>
  );
});
